import { Upload, X } from 'lucide-react';
import { useEffect, useId, useState } from 'react';

interface FileDropProps {
  label: string;
  value?: File;
  onChange: (file: File) => void;
  onRemove?: () => void;
  removeLabel?: string;
}

export function FileDrop({ label, value, onChange, onRemove, removeLabel = 'Remove photo' }: FileDropProps) {
  const inputId = useId();
  const [isDragging, setIsDragging] = useState(false);
  const [previewUrl, setPreviewUrl] = useState('');

  useEffect(() => {
    if (!value) {
      setPreviewUrl('');
      return;
    }

    const url = URL.createObjectURL(value);
    setPreviewUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [value]);

  return (
    <div className="file-drop-shell">
      <label
        className={`file-drop ${isDragging ? 'is-dragging' : ''}`}
        htmlFor={inputId}
        onDragOver={(event) => {
          event.preventDefault();
          setIsDragging(true);
        }}
        onDragLeave={() => setIsDragging(false)}
        onDrop={(event) => {
          event.preventDefault();
          setIsDragging(false);
          const file = event.dataTransfer.files[0];
          if (file) onChange(file);
        }}
      >
        <input
          accept="image/*"
          id={inputId}
          type="file"
          onChange={(event) => {
            const file = event.currentTarget.files?.[0];
            if (file) onChange(file);
            event.currentTarget.value = '';
          }}
        />
        {previewUrl ? (
          <img alt="" className="file-preview-image" src={previewUrl} />
        ) : (
          <>
            <Upload size={22} strokeWidth={2.2} />
            <span>{label}</span>
          </>
        )}
        {value && <span className="file-name">{value.name}</span>}
      </label>
      {onRemove && (
        <button className="file-remove-button" type="button" aria-label={removeLabel} title={removeLabel} onClick={onRemove}>
          <X aria-hidden="true" size={18} strokeWidth={2.3} />
        </button>
      )}
    </div>
  );
}
